import '../Styles/HeaderSt.css';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNumProds } from '../Helpers/getNumProds';
import { simpleAction } from '../Redux/actions/simpleAction';
import logo from '../Icons/elrancho_logo2.png';
import Carrito from './Carrito';


const Header = props => {

    const dispatch = useDispatch()
    useEffect(()=>{
        let carrito = window.localStorage.getItem('carrito');
        if (carrito === null){
            localStorage.setItem('carrito', JSON.stringify([]));
            console.log(carrito)
        };
        getNumProds(dispatch, simpleAction);
    }, [])

    const numbersDucer = useSelector(state => state.numbersDucer)

    return(
        <header>
            <div className="Logo-container">
                <a className="Link-logo" href="/">
                    <img src={logo}></img>
                </a>
            </div>
            <div className="Name-container">
                <a className="Link-title">
                <p className="title">{props.title}</p>
                </a>
            </div>
            <div className="Cart-container">
                <a className="Link-cart" onClick={()=>{dispatch({type: "carrito"})}}>
                    <img src="Img/carrito.png"></img>
                </a>
                <div className="Counter">{
                    localStorage.getItem("carrito") === null
                    ? 0
                    : numbersDucer.totalProds
                }</div>
            </div>
            
        </header>
    )
}
export default Header;